import { Element } from '../../../../../common/html/element'
import { STATUS_COLOR } from '../../../constant'
import classes from '../../index.module.scss'

const StatusCell = ({ val }) => {
  return (
    <Element
      elementName="span"
      className={classes.statusCell}
      style={{
        fontSize: 10,
        backgroundColor: STATUS_COLOR[val.activeStatusId] || '#3DA967',
        color: '#ffffff',
      }}
    >
      {val.activeStatusName}
    </Element>
  )
}

export default StatusCell
